import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";
import { TAppVersion } from "../types";

type VersionListParams = { platform?: string; page?: number; limit?: number };
type VersionCallbacks = { onSuccess?: (res: any) => void; onError?: (err: any) => void };

export const useAppVersionList = (qData: VersionListParams = { limit: 100 }) => {
  return useQuery({
    queryKey: [API_ENDPOINTS.APP_VERSION, qData],
    queryFn: () => client.get(API_ENDPOINTS.APP_VERSION, { params: qData }),
    select: (res: any) => res.data.data as TAppVersion[],
    refetchOnWindowFocus: false,
  });
};

export const useAppVersionSave = ({ onSuccess, onError }: VersionCallbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      data.id
        ? client.put(API_ENDPOINTS.APP_VERSION + data.id, data)
        : client.post(API_ENDPOINTS.APP_VERSION, data),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.APP_VERSION] });
      onSuccess?.(res);
    },
    onError: (err) => onError?.(err),
  });
};

export const useAppVersionDelete = ({ onSuccess, onError }: { onSuccess?: () => void; onError?: () => void } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => client.delete(API_ENDPOINTS.APP_VERSION + id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.APP_VERSION] });
      onSuccess?.();
    },
    onError: () => onError?.(),
  });
};
